import apiClient from './apiClient';

const camService = {
  // Crear una nueva cámara
  createCam: async (camData) => {
    try {
      console.log('Sending cam data to backend:', JSON.stringify(camData, null, 2));
      const response = await apiClient.post('/cams/addCam', camData);
      console.log('Response from backend:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error details:', {
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
        data: error.response?.data
      });
      throw error;
    }
  },

  // Obtener todas las cámaras
  getAllCams: async () => {
    try {
      const response = await apiClient.get('/cams/getAll');
      return response.data;
    } catch (error) {
      console.error('Error al obtener cámaras:', error);
      throw error;
    }
  },

  // Obtener cámara por ID
  getCamById: async (idCam) => {
    try {
      const response = await apiClient.get(`/cams/getById?idCam=${idCam}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener cámara ${idCam}:`, error);
      throw error;
    }
  },

  // Actualizar una cámara existente
  updateCam: async (idCam, camData) => {
    try {
      console.log('Updating cam data:', JSON.stringify(camData, null, 2));
      const response = await apiClient.put(`/cams/updateCam?idCam=${idCam}`, camData);
      console.log('Update response:', response.data);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar cámara ${idCam}:`, error);
      throw error;
    }
  },

  // Eliminar una cámara
  deleteCam: async (idCam) => {
    try {
      const response = await apiClient.delete(`/cams/deleteCam?idCam=${idCam}`);
      return response.data;
    } catch (error) {
      console.error(`Error al eliminar cámara ${idCam}:`, error);
      throw error;
    }
  }
};

export default camService;